import { LayoutGrid, Menu, X } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router";
import UTILS from "../../utils/commons";

const Header = ( {auth} ) => {
  const [ showMenu, setShowMenu ] = React.useState( false );
  let navigate = useNavigate();

  if( !auth ) navigate( "/login", { replace: true, target: "/dashboard" } );
  const signout = ( e ) => {
    // e.preventDefault();
    if ( window.confirm( "Are you sure you want to sign out?" ) ) {
      sessionStorage.clear();
      localStorage.clear();
      navigate( "/" );
    }
  }
  
    return ( <header className="w-full m-0 p-0">
      <div className="hidden w-full bg-orange-500 md:h-16 md:block md:flex justify-between items-start p-2 mb-12 z-0">
        <div className="flex justify-start items-center ">
        <LayoutGrid size={36} className="text-white my-2 mx-4 cursor-pointer" onClick={() => { navigate( '/dashboard', { replace: true } ) }} />
         <span className="text-white uppercase"> {auth.role }</span>
         </div>
        <nav className="flex justify-evenly items-center">
          {auth ? <a className="mx-4 cursor-pointer text-green-800 hover:font-bold transition-all duration-200 text-white" href="/settings" id="login">{auth.firstName + " " + auth.lastName}</a> : null}
          <a className="mx-4 cursor-pointer text-green-800 hover:font-bold transition-all duration-200 text-white" href="/help">Help</a>
          <button className="mx-4 cursor-pointer text-green-800 hover:font-bold transition-all duration-200 text-white bg-transparent border-none" onClick={() => signout()} >Sign out</button>
        </nav>
      </div>
      <div className="w-full bg-orange-500 md:h-16 p-2 mb-12 z-0 md:hidden">
        <div className="flex justify-between item-start w-full">
          <LayoutGrid size={36} className="text-2xl text-white m-2 cursor-pointer" onClick={() => { navigate( '/dashboard', { replace: true } ) }}/>
          {showMenu ? <X className="md:hidden text-white m-4 " onClick={() => { setShowMenu( !showMenu ) }} /> : <Menu className="md:hidden text-white m-4" onClick={() => { setShowMenu( !showMenu ) }} />}
        </div>
        <div className="md:hidden w-full flex justify-end">

          {showMenu ?
            <div className="from-orange-500 to-transparent flex flex-col justify-start items-start p-4 z-10 w-full">
              {auth ? <a className="mx-4 cursor-pointer text-green-800 hover:font-bold transition-all duration-200 text-white border-b border-b-white" href="/settings" id="login">{auth.firstName + " " + auth.lastName}</a> : null}
              <a className="mx-4 cursor-pointer text-green-800 hover:font-bold transition-all duration-200 text-white border-b border-b-white" href="/help">Help</a>
              <button className="mx-4 cursor-pointer text-green-800 hover:font-bold transition-all duration-200 text-white border-b border-b-white bg-transparent border-none text-left" onClick={() => signout()} >Sign out</button>
            </div> : null}
        </div>
      </div>
    </header> )
 
}
export default Header;